import { Injectable } from '@angular/core';
import { Settings } from 'src/app/app.settings.model';
import { environment } from 'src/environments/environment';
import { AppSettings } from 'src/app/app.settings';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Utils } from 'src/app/core/utils';


@Injectable({
  providedIn: 'root'
})
export class StandbyService {
  settings: Settings;
  apiEndPoint: string = Utils.getApiEndPoint(); // environment.APIEndpoint;

  constructor(
    private http: HttpClient,
    public router: Router,
    public appSettings: AppSettings) {

    this.settings = appSettings.settings;
  }


  getBranches(practiceID?: number) {

    practiceID = practiceID ? practiceID : 0;
    return this.http.get<any>(this.apiEndPoint + `StandbyApi/GetBranches/${practiceID}`)
      .pipe(map(result => {
        return result;
      }));
  }

  /** return responseModel object {Code, Data, Error} */
  getSchedulers(practiceID?: number, branchID?: number) {

    practiceID = practiceID ? practiceID : 0;
    branchID = branchID ? branchID : 0;
    return this.http.get<any>(this.apiEndPoint + `StandbyApi/GetSchedulers/${practiceID}/${branchID}`)
      .pipe(map(result => {
        return result;
      }));
  }

  /**
   * Get rooms
   * @param practiceID  practiceID
   * @param branchID branchID
   * @param schedulerFilter schedulerFilter string
   * @param fromTime fromTime any
   * @param toTime toTime any
   * @param sunday sunday boolean
   * @param monday boolean
   * @param tuesday  boolean
   * @param wednesday boolean
   * @param thursday boolean
   * @param friday boolean
   * @param saturday boolean
   */
  getRooms(practiceID: number, branchID: number, schedulerFilter: string,
    fromTime: any, toTime: any,
    sunday: boolean, monday: boolean,
    tuesday: boolean, wednesday: boolean,
    thursday: boolean, friday: boolean, saturday: boolean) {

    // due to line error Exceeds maximum line length of 140
    const url = this.apiEndPoint +
      'StandbyApi/GetSchedulersRooms/' +
      `${practiceID}/` +
      `${branchID}/` +
      `${schedulerFilter}/` +
      `${fromTime}/${toTime}/` +
      `${sunday}/${monday}/${tuesday}/${wednesday}/${thursday}/${friday}/${saturday}`;

    return this.http.get<any>(url)
      .pipe(map(result => {
        return result;
      }));
  }

  // todo: should be replaced latter with treatment or pricelist
  getVisitReasons(schedulerID?: number) {
    schedulerID = schedulerID || 0;

    return this.http.get<any>(this.apiEndPoint + `StandbyApi/GetVisitReasons/${schedulerID}`)
      .pipe(map(result => {
        return result;
      }));
  }

  getWaitListByEventID(eventID: number) {

    return this.http.get<any>(this.apiEndPoint + `StandbyApi/GetModelByEventID/${eventID}`)
      .pipe(map(result => {
        return result;
      }));
  }

  GetModelByWaitListItemID(wailistItemID: number) {
    return this.http.get<any>(this.apiEndPoint + `StandbyApi/GetModelByWaitListItemID/${wailistItemID}`)
      .pipe(map(result => {
        return result;
      }));
  }

  createStandBy(model: any) {
    return this.http.post<any>(this.apiEndPoint + `StandbyApi/Create`, JSON.stringify(model))
      .pipe(map(result => {
        return result;
      }));
  }

  updateStandBy(id: number, model: any) {
    return this.http.put<any>(this.apiEndPoint + `StandbyApi/Update/${id}`, JSON.stringify(model))
      .pipe(map(result => {
        return result;
      }));
  }

}
